import { NuxtLink } from "#components"

export default {
  props: {
    tagName: {
      type: String,
      default: 'button',
      validator (value) {
        return ['button', 'a', 'o-panel-link', 'o-button', 'nuxt-link'].includes(value)
      }
    }
  },
  computed: {
    isInertiaLinkComponentAvailable () {
      return !!this.$options.components?.InertiaLink
    },
    isRouterLinkComponentAvailable () {
      return !!(this.$options.components?.RouterLink || this.$options.components?.NuxtLink)
    },
    isARouterLink () {
      return this.to !== undefined //  && this.isRouterLinkComponentAvailable
    },
    componentToRender () {
      if (this.isARouterLink) {
        return NuxtLink
      }

      if (this.href) {
        return 'a'
      }
      return this.tagName
    }
  }
}
